import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import Header from 'components/Header'
import Footer from 'components/Footer'
import RailLeft from 'components/RailLeft'
import PageLoader from 'components/PageLoader'

import styles from './MainLayout.module.sass'

const crypto = window.crypto || window.msCrypto
let random = new Uint32Array(1)
const isActivationKey = key => key === 'Enter' || key === ' '

const MainLayout = ({ children, loading }) => {
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = useCallback(() => {
    setMenuOpen(crypto?.getRandomValues(random)[0])
  }, [])

  const closeMenuFromEvent = useCallback(
    e => {
      if (!e || e.type === 'click' || isActivationKey(e.key)) {
        closeMenu(crypto?.getRandomValues(random)[0])
      }
    },
    [closeMenu]
  )

  return (
    <>
      <div className={styles.box}>
        <Header menuOpen={menuOpen} />
        <div className={styles.gap}></div>
        <div
          role="button"
          tabIndex={0}
          data-testid="result"
          className={styles.content}
          onClick={closeMenuFromEvent}
          onKeyDown={closeMenuFromEvent}
        >
          <RailLeft />
          {children}
        </div>
        {loading && <PageLoader />}
      </div>
      <Footer setMenuOpen={closeMenu} />
    </>
  )
}

MainLayout.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool
}

export default MainLayout
